<template>
    <div class="d-flex flex-column flex-1">
        <b-pagination
            v-model="local_page"
            :total-rows="total"
            :per-page="limit"
            @input="pageChanged"
        ></b-pagination>
    </div>
</template>

<script>
export default {
    name: "pagination_list",

    props: {
        total: {
            type: Number,
            required: true
        },
        limit: {
            type: Number,
            default: 30
        },
        current: {
            type: Number,
            default: 1
        }
    },

    data() {
        return {
            local_page: this.current
        };
    },

    watch: {
        current(val) {
            this.local_page = val;
        }
    },

    methods: {
        pageChanged(page) {
            const start = (page - 1) * this.limit;
            this.$emit('page-change', { page, start });
        }
    }
};
</script>

<style scoped>
</style>
